import type { KanbanTaskView } from '@nexelem/graphne-api';
import { getDuration, useDateFormatter } from '@nexelem/utils';
import { differenceInDays } from 'date-fns';

export const useKanbanFormatTaskDuration = () => {
  const formatterHours = useDateFormatter({ onlyHours: true });
  const formatterWithHours = useDateFormatter({ displayWithHours: true });

  return ({ start, end }: Pick<KanbanTaskView, 'start' | 'end'>) => {
    const now = new Date();
    const startDate = new Date(start);
    const endDate = new Date(end);

    const startDateTime =
      differenceInDays(now, startDate) > 0 ? formatterWithHours(startDate) : formatterHours(startDate);
    const endDateTime = differenceInDays(now, endDate) > 0 ? formatterWithHours(endDate) : formatterHours(endDate);
    return `${startDateTime} - ${endDateTime} (${getDuration(startDate, endDate, ['seconds'])})`;
  };
};
